import { useMemo } from "react";
import { useDocsDirectories } from "../../api/documentsApi";
import { Link } from "react-router-dom";

const DocsCheckHome = () => {
  const { data } = useDocsDirectories();
  const directories = useMemo(() => data?.directories, [data]);

  return directories ? (
    <div className="narrowContent">
      {directories.map((dir: string) => (
        <Link to={dir}>
          <button key={dir} style={{ width: "100%", marginBottom: "10px" }}>
            {dir}
          </button>
        </Link>
      ))}
    </div>
  ) : (
    <p>로딩 중...</p>
  );
};

export default DocsCheckHome;
